import AmpEvents from '@amplify/amp-events'
import EnvConstants from 'app/services/core/config.service'
import { LOCAL_STORAGE_KEYS } from 'app/constants/local-storage.constant'
import { getCurrentPage } from 'app/services/analitics/util'
import packageJson from '../../../../package.json'

class EventService {
  public language: string
  public soundUnit: string
  private userId: string
  private ampEvents: typeof AmpEvents

  constructor() {
    this.language = ''
    this.userId = ''
    this.ampEvents = null
    this.soundUnit = ''
  }

  // Initialize the service by setting up an event factory with configuration for CKLA Hub.
  init(userId: string) {
    this.language = 'en-US'
    this.userId = userId
    this.ampEvents = new AmpEvents({
      [AmpEvents.OPTIONS.APP_NAME]: packageJson.name,
      [AmpEvents.OPTIONS.APP_VERSION]: packageJson.version,
      [AmpEvents.OPTIONS.LANGUAGE]: this.language,
      [AmpEvents.OPTIONS.ENVIRONMENT]: EnvConstants.ENVIRONMENT,
      [AmpEvents.OPTIONS.USER_ID]: userId,
    })
  }

  getEvents() {
    return this.ampEvents
  }

  // Create a new xAPI event. Throws an error if the service is not initialized.
  createEvent() {
    if (!this.ampEvents) {
      throw new Error('EventService is not initialized!')
    }

    return this.ampEvents.eventFactory
      .create()
      .addActorAccount('name', this.userId) // required
      .addContextExtension(
        'grade-level',
        localStorage.getItem(LOCAL_STORAGE_KEYS.GRADE)
      )
  }

  // Send an xAPI event when user is logged in.
  sendLoginEvent() {
    return this.createEvent()
      .addContextExtension('hub-section', getCurrentPage())
      .addVerbId('logged-in')
      .addVerb('display', { [this.language]: 'logged-in' })
      .addObject('id', 'ckla-hub')
      .addObjectDefinition('objectType', 'Activity')
      .emit()
  }

  // Send an xAPI event when user is logged out vie modal window.
  sendLogoutEvent() {
    return this.createEvent()
      .addContextExtension('hub-section', getCurrentPage())
      .addVerbId('logged-out')
      .addVerb('display', { [this.language]: 'logged-out' })
      .addObject('id', 'ckla-hub')
      .addObjectDefinition('objectType', 'Activity')
      .emit()
  }
}

export default new EventService()
